import script from "./Reject.vue?vue&type=script&setup=true&lang=ts"
export * from "./Reject.vue?vue&type=script&setup=true&lang=ts"

import "./Reject.vue?vue&type=style&index=0&id=58aea178&lang=less&scoped=true"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58aea178"]])

export default __exports__